import React, { useEffect, useState } from 'react'

import useStyles from './styles/ProgressComponent.styles'

interface Props {
  circlesColor: string
  numberOfCircles: number
}

const ProgressComponent: React.FC<Props> = ({
  numberOfCircles,
  circlesColor
}) => {
  const classes = useStyles()
  const [circleIndex, setCircleIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCircleIndex((prevIndex) => (prevIndex + 1) % numberOfCircles)
    }, 500)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className={classes.container}>
      <div className={classes.spinner}>
        {Array(numberOfCircles)
          .fill(' ')
          .map((_, index) => (
            <div
              style={{ backgroundColor: `${circlesColor}` }}
              key={index}
              className={`${classes.circle} ${
                index === circleIndex ? classes.activeCircle : ''
              }`}
            />
          ))}
      </div>
    </div>
  )
}

export default ProgressComponent
